import {SELECT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: SELECT,
  attribute: 'repo_outcome',
  label: {
    default: 'Deactivation Outcome',
    short: 'Outcome',
  },
  options: [
    {
      key: 'partial_payment_reactivation',
      label: '  Partial Payment - Reactivation',
    },
    {
      key: 'partial_payment_no_reactivation',
      label: 'Partial Payment - No Reactivation',
    },
    {key: 'full_payment_reactivation', label: 'Full Payment - Reactivation'},
    {
      key: 'contract_termination_no_reactivation',
      label: 'Contract Termination - No Reactivation',
    },
    {
      key: 'contract_termination_reactivation',
      label: 'Contract Termination - Reactivation',
    },
    {
      key: 'contract_termination_reversal',
      label: 'Contract Termination Reversal',
    },
    {key: 'migrated', label: 'Migrated'},
  ],
});
